(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

//import 'code-prettify';

/* Since 1.1.0*/
if (extreme.cookieInfoActive) {

            /* Cookieinfo Extreme*/

            (function () {

                        if (Cookies.get('cookieinfo')) {
                                    return false;
                        }

                        var container = document.createElement('div'),
                            spancontent = document.createElement('div'),
                            rowcont = document.createElement('div'),
                            link = document.createElement('a');

                        container.setAttribute('id', 'cookieinfo');
                        container.setAttribute('class', 'cookie-alert');

                        spancontent.innerHTML = '<span>' + extreme.cookieInfoValue + '</span>';

                        spancontent.setAttribute('class', 'cookieInfoContent');

                        link.setAttribute('href', '#');
                        link.setAttribute('title', 'OK');
                        link.innerHTML = 'Zgoda';
                        link.setAttribute('class', 'dfd-button-link button mini transparent');
                        link.classList.add('accept');
                        rowcont.setAttribute('class', 'row');

                        function clickHandler(e) {
                                    if (e.preventDefault) {
                                                e.preventDefault();
                                    } else {
                                                e.returnValue = false;
                                    }

                                    container.style.transition = '1s';
                                    container.style.opacity = '0';

                                    Cookies.set('cookieinfo', 'true', { expires: 365 });

                                    document.body.removeChild(container);
                        }

                        if (link.addEventListener) {
                                    link.addEventListener('click', clickHandler);
                        } else {
                                    link.attachEvent('onlick', clickHandler);
                        }

                        rowcont.appendChild(spancontent).appendChild(link);;
                        container.appendChild(rowcont);
                        document.body.appendChild(container);

                        return true;
            })();
}

},{}]},{},[1]);
